import { useMutation, useQuery } from "@tanstack/react-query"
import axiosInstance from "../../api/axiosInstance"

export const useAddProjectKey = () => {
  return useMutation({
    mutationFn: async ({ projectId, projectKey }) => {
      const response = await axiosInstance.post(`/projects/add_project_key?project_id=${projectId}&project_key=${projectKey}`);
      return response;
    }
  });
}


export const useJiraProjectDetails = (projectId) => {
  return useQuery({
    queryKey: ['jiraProjectDetails', projectId],
    queryFn: async () => {
      const response = await axiosInstance.get(
        `/jira_data/get_jira_project_details?project_id=${projectId}`
      );
      return response?.project;
    },
    enabled: !!projectId,
  });
};

 export const useGetProjectDetails=(projectId)=>{
  return useQuery({
    queryKey:['individualProjectDetail', projectId],
    queryFn: async ()=>{
      const response = await axiosInstance(`projects/get_project?project_id=${projectId}`);
      return response;
    }
  })
 }